import type { PanelMessageIn } from './types'

/*
 * Deprecated
 */
export function checkDotNet() {
  return checkPollinationPanel()
}

/*
 * Deprecated
 */
export function checkRuby() {
  return checkPollinationPanel()
}

export function checkPollinationPanel(silent=true) {
  try {
    if (window.parent.chrome == null)
    {
      !silent && new Error('[POLLINATION-DEBUG]: chrome not found.')
      return false
    }
    if (window.parent.chrome.webview == null)
    {
      !silent && new Error('[POLLINATION-DEBUG]: webview not found.')
      return false
    }
    if (window.parent.chrome.webview == null)
    {
      !silent && new Error('[POLLINATION-DEBUG]: webview not found.')
      return false
    }
  
    return true
  } catch (error) {
    !silent && new Error('[POLLINATION-DEBUG]: webview not supported.')
    return false
  }
}

export function sendMessageDotNet(message: PanelMessageIn) {
  if (!checkPollinationPanel()) return undefined

  // const json = JSON.stringify(message)

  const json = message
  
  if ( typeof message.data !== 'string') {
    json.data = JSON.stringify(message.data)
  }

  try {
    window.parent.chrome.webview.postMessage(json)
  } catch {
    throw new Error('Failed to post message to dotNet.')
  }

  return message
}

export function sendMessageRuby(message?: PanelMessageIn) {
  if (!checkPollinationPanel()) return undefined

  throw new Error('[POLLINATION-DEBUG]: sendMesssageRuby not yet implemented')
}

// not sure if this will work from Streamlit?
export function getHost(key = '__host__', defaultValue: 'web' | 'rhino' | 'revit' | 'sketchup' = 'web'): 'web' | 'rhino' | 'revit' | 'sketchup' {
  // getting stored value
  const retrieved = localStorage.getItem(key)
  if (!retrieved) return defaultValue
  return typeof retrieved === 'string' ? retrieved.toLowerCase() : JSON.parse(retrieved).toLowerCase()
}

export const recipeLinkFromSource = (source: string): string => {
  if (!source) return

  const splitSource = source.split('/')
  const tag = splitSource.pop()
  const name = splitSource.pop()
  splitSource.pop()
  const owner = splitSource.pop()
  return `/${owner}/recipes/${name}/${tag}`
}

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
